// utils/dateUtils.js
import React from "react";

export const formatDate = (dateString) => {
  if (!dateString) return "Date not available";

  let date;
  if (dateString.endsWith("Z")) {
    date = new Date(dateString);
  } else {
    date = new Date(dateString.replace(" ", "T") + "Z");
  }

  const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  const now = new Date();
  const isClosed = date.getTime() < now.getTime();

  const day = days[date.getDay()];
  const d = String(date.getDate()).padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return (
    <>
      <strong>{isClosed ? "Closed" : "Closes"}</strong>: {day} {d} {month}{" "}
      {year} {hours}:{minutes} {ampm}
    </>
  );
};
